import React from 'react';

// Material UI
import { Grid, Typography } from "@mui/material";

// Components
import Input from "../../../../../components/inputs/input";
import { subTypesFormat } from "../../../../../models/CashRegisterMovementEntity";
import { utils } from "../../../../../utils/utils";

const RealTotal = ({ detail, type, onChange }) => (
    <Grid container spacing={2} alignItems='center'>
        <Grid size={2}>
            <Typography color='primary' variant='subtitle1' component='p'>
                <strong>{subTypesFormat[type]}:</strong>
            </Typography>
        </Grid>
        <Grid size={2}>
            <Typography variant='body1' align='right'>
                $ {utils.formatMoney(detail[type]?.total ? detail[type].total : 0)}
            </Typography>
        </Grid>
        <Grid size={3}>
            <Input
                required
                fullWidth
                size='small'
                key="total"
                name="realTotal"
                label="Total"
                onChange={(e) => onChange(e, type)}
                value={detail[type]?.realTotal >= 0 ? detail[type]?.realTotal : ''}
            />
        </Grid>
        <Grid size={2}>
            <Typography variant='body1' align='right'>
                {detail[type]?.count ? detail[type].count : 0}
            </Typography>
        </Grid>
        <Grid size={3}>
            <Input
                required
                fullWidth
                size='small'
                key="count"
                name="realCount"
                label="Cupones"
                onChange={(e) => onChange(e, type)}
                value={detail[type]?.realCount >= 0 ? detail[type]?.realCount : ''}
            />
        </Grid>
    </Grid>
)

export default RealTotal;